<script>
import AdminLayout from '@layouts/admin-main'
import BalanceList from '@components/admin/brokerage-balance-list'

export default {
  page: {
    title: 'Admin::BrokerageBalanceList',
    meta: [{ name: 'description', content: 'Admin::BrokerageBalanceList' }],
  },
  components: { AdminLayout, BalanceList },
}
</script>

<template>
  <AdminLayout>
    <BalanceList></BalanceList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
